import { Table } from "@/pages/a7/Table";

import { type A7OPCVMIssuerTS, getIssuerTsColumns } from "./columns";
import {
  type FilterA7OPCVMIssuerTSSchema,
  FilterA7OPCVMIssuerTS,
} from "./filter";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_opcvm_issuer_ts";

export const A7OPCVMIssuerTSTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getIssuerTsColumns(t), [t, i18n.language]);

  return (
    <Table<A7OPCVMIssuerTS, FilterA7OPCVMIssuerTSSchema>
      client="a7"
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Issuer time series",
      })}
      table_name={table_name}
      columns={columns}
      filter={<FilterA7OPCVMIssuerTS table_name={table_name} />}
    />
  );
};
